export default __webpack_public_path__ + "static/media/octodns.ba2ddfdb.svg";